<div class="card border-primary ui-g" style="display: block; padding: .5em;">
    <!-- <div class="ui-g-12"> -->
    <div class="ui-g ui-fluid">


        <p-table class="ui-g-12" [value]="listCursoDisp" [(selection)]="selCursoDisp" dataKey="codCurso"
            selectionMode="single" [responsive]="true" autoLayout="true" [paginator]="true" [rows]="5" [lazy]="true"
            [totalRecords]="countDisponible" (onLazyLoad)="onHNPPage($event)" [(first)]="first"
            (onRowSelect)="onRowSelect($event)">



            <!-- (onLazyLoad)="onPage($event)" 
                [totalRecords]="listCount"
        -->

            <!-- <p-table class="ui-g-12" [value]="listCursoDisp" [(selection)]="selCursoDisp" selectionMode="single"
            [responsive]="true" autoLayout="true" [paginator]="true" [rows]="7"> -->

            <ng-template pTemplate="caption">
                Cursos Disponibles
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th style="width:40%">Tema</th>
                    <th style="width:20%">Fecha de Programación</th>
                    <th style="width:20%">Hora inicio</th>
                    <th style="width:20%">Duracion</th>


                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-Disponible>
                <tr [pSelectableRow]="Disponible">
                    <td><span class="ui-column-title">Tema</span>{{Disponible.tema}}</td>
                    <td><span class="ui-column-title">Fecha de Programación</span>{{formatoFecha(Disponible.fechaIni)}}</td>
                    <td><span class="ui-column-title">Hora inicio</span>{{Disponible.horaInicio}}</td>
                    <td><span class="ui-column-title">Duracion</span>{{Disponible.duracion}} hora(s)</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>





<!--     popUp seleccionar curso -->
<p-dialog header="Detalle del curso" [(visible)]="verDetalle"
    [style]="{  width: '50%', minHeight: '150px', maxHeight: '80vh'}"
    [contentStyle]="{'overflow-x': 'hidden', 'max-height': '60vh', 'min-height': '250px'}" [minY]="70" [modal]="true"
    [draggable]="true" [resizable]="true" dismissableMask="true" [responsive]="true" [maximizable]="true"
    [baseZIndex]="1000" (onHide)= "onHide($event)">
    <p-header>
    </p-header>

    <ng-container>

        <div class="ui-g ui-fluid">
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Tema: </label>
                <label > {{cursodetalle.tema}}</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">tipo: </label>
                <label > {{getDesTipo(cursodetalle.tipo)}}</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Puntaje total: </label>
                <label > {{cursodetalle.puntajeTotal}}</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Capacidad / Disponibles: </label>
                <label > {{cursodetalle.capacidad}}/{{cursodetalle.disponibles}}</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Fecha programada: </label>
                <label > {{formatoFecha(cursodetalle.fechaIni)}}</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Fecha de finalización: </label>
                <label > {{formatoFecha(cursodetalle.fechaFinal)}}</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Duración: </label>
                <label >{{cursodetalle.duracion}} hora(s)</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Vigencia: </label>
                <label > {{cursodetalle.vigencia}} {{getVigencia(cursodetalle.codVigenciaCapacita)}}</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Empresa Capacitadora: </label>
                <label > {{getEmpresa(cursodetalle.codEmpresaCap)}}</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Expositor (es): </label>
                <!-- <label > {{cursodetalle.expoName}}</label> -->
                <li *ngFor="let expositor of cursodetalle.expositores" style="text-align: left">
                   <a> {{expositor.nombre}}  </a> 
                </li>
            </div>


        </div>

    </ng-container>

    <p-footer>

        <div class="ui-g ui-fluid">
            <div class="ui-g-12 ui-md-12">
                <ng-container *ngIf="!cursodetalle.inscrito ; else notShow">
                    <button type="button" pButton (click)="InscripcionCurso()" label="Inscribirme" class="ui-button-info"
                    style="width: 100%;"></button>
                </ng-container>
                <ng-template #notShow>
                    <button type="button" pButton (click)="DesinscripcionCurso()" label="Eliminar Inscripcion" class="ui-button-danger"
                    style="width: 100%;"></button>
                </ng-template>
            </div>



        </div>




    </p-footer>
</p-dialog>